import { ca } from '@cian/analytics';

export function trackClearClick() {
  ca('eventSite', {
    name: 'oldevent',
    action: 'clean_filters',
    category: 'Map',
  });
}

export function trackAdvancedFiltersClick() {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click',
    category: 'Map',
    label: 'Filters',
  });
}

export function trackApplyClick(queryString?: string) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'button_search',
    label: queryString,
    category: 'Map',
  });
}
